import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import UserSessionLayer from "./UserSessionLayer";


const UserSessionPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Sponsors" />

                {/* SupportLayer */}
                <UserSessionLayer />

            </MasterLayout>
        </>
    );
};

export default UserSessionPage;
